var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        font-size: 25px;\r\n        fill: #27eac8;\r\n        text-anchor: middle;\r\n        font-family: Roboto;\r\n      }\r\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    className: "cls-1",
    transform: "matrix(1.437, 1.434, -1.437, 1.434, -0.832, 23.066)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "+"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape5.ca7e0baf4eddb0f2d1d4993844fa45a7.svg";
export { ForwardRef as ReactComponent };